import React from "react";
import { Button, FormField, Input } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/pro-solid-svg-icons";

import MainLayout from "../../layout";

import "./index.scss";

const CustomerInfoScreen = ({ communication, customerEmail, customerPhoneNumber, onUpdateCustomerInfo, onGoToNextScreen, t }) => {
  const getCustomerName = () => {
    let fullname = "";

    if (communication.customer) {
      if (communication.customer.title) fullname += communication.customer.title + " ";

      if (communication.customer.firstname) fullname += communication.customer.firstname + " ";

      if (communication.customer.surname) fullname += communication.customer.surname;
    }

    return fullname;
  };

  const content = (
    <div className="CustomerInfoScreenModalContainer">
      <div className="CustomerInfoScreenModal">
        <div className="CustomerInfoScreenModal__Header">{t("cc_contact_info_check").message || "Contact Info check"}</div>
        <div className="CustomerInfoScreenModal__Content">
          <div className="customer-name">
            <span>{t("cc_Welcome").message || "Welcome"}</span>
            {getCustomerName()},
          </div>
          <div className="info-message">
            {t("cc_desk_checkin_customer_info_message").message || "Check your contact information below and add or change your email address or phone number if needed."}
          </div>

          <FormField className="input-field">
            <label>{t("cc_email").message || "Email"}</label>
            <Input name="customerEmail" fluid value={customerEmail} onChange={onUpdateCustomerInfo} autoComplete="off" />
          </FormField>
          <FormField className="input-field">
            <label>{t("cc_phone_number").message || "Phone Number"}</label>
            <Input name="customerPhoneNumber" fluid value={customerPhoneNumber} onChange={onUpdateCustomerInfo} autoComplete="off" />
          </FormField>
        </div>
      </div>
    </div>
  );

  const navigationButtons = (
    <Button className="DeskCheckinNavigationButton" onClick={onGoToNextScreen}>
      <span className="navigation-text">{t("cc_next").message || "NEXT"}</span>
      <FontAwesomeIcon icon={faArrowRight} className="navigation-icon" />
    </Button>
  );

  return <MainLayout content={content} navigationButtons={navigationButtons} showTitle isCheckingOut={communication.is_checking_out} />;
};

export default withTranslation()(CustomerInfoScreen);
